"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createResultProps = createResultProps;
exports.isDirty = isDirty;
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
function createResultProps(partial, stale, data, entities) {
    if (partial) {
        return {
            type: "PartialResultProps"
        };
    }
    if (stale) {
        return {
            type: "StaleResultProps",
            data: data,
            entities: entities
        };
    }
    return {
        type: "LoadedResultProps",
        data: data,
        entities: entities
    };
}
function isDirty(resultProps) {
    switch (resultProps.type) {
        case "StaleResultProps":
        case "PartialResultProps": {
            return true;
        }
        case "LoadedResultProps":
        case "ErrorResultProps": {
            return false;
        }
        default: {
            (0, ts_exhaustive_check_1.exhaustiveCheck)(resultProps, true);
            return false;
        }
    }
}
//# sourceMappingURL=result-props.js.map